import {Col, Progress, Row, Typography} from "antd";
import React from "react";

const ProgressStat = ({ title, value, icon, color='var(--green)', prefix='',
                       suffix='', valueLevel=5, colorText='#000'}) => {

  return (
    <div style={{ width: 240 }} >
        <Row justify={'start'} align={'middle'} gutter={8}>
            <Col flex={'0 0 45px'}>
                <Progress
                  type="circle"
                  trailColor="#ddd"
                  status={'normal'}
                  strokeColor={color}
                  percent={value}
                  size={35}
                  strokeWidth={5}
                  format={(number) => icon}
                />
            </Col>
            <Col>
                <Typography.Text style={{fontWeight: 300, fontSize: '16px'}}>{title}</Typography.Text>
            </Col>
        </Row>
        <div style={{marginLeft: '18px', borderLeft: '2px solid #ddd', height: 40, marginTop: 10}}>
            <Typography.Title level={valueLevel} style={{fontWeight: '500', paddingTop: 10, marginLeft: 25, color: colorText}}>{prefix}{value}{suffix}</Typography.Title>
        </div>


    </div>
  );
};
export default ProgressStat;